import { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactUs.css'; // Assuming you have a CSS file for custom styles
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

function ContactUs() {
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        // In a real app, you would handle form submission here (e.g., send data to an API)
        if (form.checkValidity() === true) {
            event.preventDefault();
            alert('Form submitted successfully!');
        }
    };

    return (
        <>
            {/* 1. Full-width Hero Image Section */}
            <div className="hero-section text-center text-white" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/OT-Surgery-3-scaled.webp')`, // Replace with your hero image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                minHeight: '40vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Container>
                    <h1 className="display-3 font-weight-bold mb-4">Empowering Surgeons, Advancing Healthcare</h1>
                    <p className="lead mb-5" style={{ maxWidth: '700px', margin: '0 auto 2rem auto' }}>
                        Leaders in Laparoscopic Surgery Training
                    </p>
                    <div>
                        <Link to="/register">
                            <Button variant="primary" size="lg" className="me-3 px-5 py-3">Get Started</Button>
                        </Link>
                        <Link to="/training-programs"> {/* Or any other relevant link */}
                            <Button variant="outline-light" size="lg" className="px-5 py-3">Learn More</Button>
                        </Link>
                    </div>
                </Container>
            </div>
            <Container fluid className="py-5">
                {/* Section 1: Contact Info Cards */}
                <Row className="mb-5 text-center justify-content-center">
                    <Col md={3} className="mb-4 mb-md-0">
                        <Card className="p-4 h-100 contact-card">
                            <Card.Body>
                                <MapPin className="contact-icon" />
                                <Card.Title as="h4" className="mb-3">Address</Card.Title>
                                <Card.Text className="text-muted">
                                    <b>Bangalore Endoscopic<br />
                                    Surgery Training Institute &<br />
                                    Research Centre<br /></b>
                                    #35, 8th Cross, JP Nagar,<br />
                                    3rd Phase, Bengaluru, Karnataka 560078
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3} className="mb-4 mb-md-0">
                        <Card className="p-4 h-100 contact-card">
                            <Card.Body>
                                <Phone className="contact-icon" />
                                <Card.Title as="h4" className="mb-3">Phone</Card.Title>
                                <Card.Text className="text-muted">
                                    +91 9019 704 252
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="p-4 h-100 contact-card">
                            <Card.Body>
                                <Mail className="contact-icon" />
                                <Card.Title as="h4" className="mb-3">Mail</Card.Title>
                                <Card.Text className="text-muted">
                                    drramesh@hotmail.com<br />
                                    bestinstituteandresearchcentre<br />@gmail.com
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Section 2: Map and Contact Form - Full Width */}
                <Row>
                    {/* Full-width Map */}
                    <Col xs={12} md={6}>
                        <div className="map-container shadow">
                            <iframe
                                src="https://maps.google.com/maps?q=6th%20phase%2C%202%2C%2015th%20Cross%20Rd%2C%20KR%20Layout%2C%20JP%20Nagar%20Phase%206%2C%20J.%20P.%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560078&t=m&z=13&output=embed&iwloc=near"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade">
                            </iframe>
                        </div>
                    </Col>

                    {/* Full-width Contact Form */}
                    <Col xs={12} md={6} className='my-5'>
                        <Row className="justify-content-center">
                            <Col lg={8} md={10}>
                                <div className="text-center">
                                    <h6 className="text-primary text-uppercase">Mail Us</h6>
                                    <h2 className="mb-4 display-5">Drop a Line</h2>
                                </div>
                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formBasicName">
                                        <Form.Control required type="text" placeholder="Name" size="lg" />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide your name.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Control required type="email" placeholder="Email Address" size="lg" />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid email address.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="formBasicMessage">
                                        <Form.Control
                                            required
                                            as="textarea"
                                            rows={5}
                                            placeholder="How can we help you? Feel free to get in touch!"
                                            size="lg"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter your message.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="formBasicCheckbox">
                                        <Form.Check
                                            required
                                            type="checkbox"
                                            label="I agree that my submitted data is being collected and stored."
                                            feedback="You must agree before submitting."
                                            feedbackType="invalid"
                                        />
                                    </Form.Group>

                                    <div className="text-center">
                                        <Button variant="success" type="submit" className="submit-btn">
                                            Submit
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </>
    );
}

export default ContactUs;